import React from 'react';
import { useNavigate } from 'react-router-dom';
import DynamicBackground from '../../components/DynamicBackground';
import '../../styles/darkMode.css';
import './NotFound.css';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const logo = process.env.PUBLIC_URL + '/SOUND_LEGAL_WHITE.png';

  return (
    <DynamicBackground>
      <div className="not-found-content">
        <img src={logo} alt="SoundLegal.ai Logo" className="not-found-logo" />
        <h1 className="not-found-title">404</h1>
        <h2 className="not-found-subtitle">Page Not Found</h2>
        <p className="not-found-description">
          Oops! The page you're looking for seems to have wandered off into the legal wilderness.
          Don't worry, we'll help you find your way back!
        </p>
        <div className="not-found-buttons">
          <button 
            className="not-found-button primary"
            onClick={() => navigate('/')}
          >
            Go Home
          </button>
          <button 
            className="not-found-button secondary"
            onClick={() => navigate(-1)}
          >
            Go Back
          </button>
        </div>
      </div>
    </DynamicBackground>
  );
};

export default NotFound; 